/** @jsx jsx */
import { jsx } from "theme-ui";
import PropTypes from "prop-types";
import Header from "./regions/header/header";
import Footer from "./regions/footer/footer";
import { SkipNavLink, SkipNavContent } from "@reach/skip-nav";
import "@reach/skip-nav/styles.css"; //this will show/hide the link on focus
import React from "react";
const Layout = (props) => {
  return (
    <React.Fragment>
      <SkipNavLink />
      <Header />
      <SkipNavContent />
      <main
        sx={{
          paddingTop: "84px",
        }}
      >
        {props.children}
      </main>
      <Footer node={props.node} />
    </React.Fragment>
  );
};

Layout.propTypes = {
  children: PropTypes.node.isRequired,
};

export default Layout;
